import React from "react";
import { 
  Container, 
  Typography, 
  Box, 
  Paper,
  Button
} from "@mui/material";
import { 
  Lock as LockIcon,
  Home as HomeIcon,
  Login as LoginIcon,
  Warning as WarningIcon
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import "../../../Landing.css";

function UnauthorizedPage() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0878ff 0%, #244a77 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 2
      }}
    >
      <Container maxWidth="md">
        <Paper
          elevation={24}
          sx={{
            padding: { xs: 4, sm: 6 },
            borderRadius: 4,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2)',
            position: 'relative',
            overflow: 'hidden',
            textAlign: 'center'
          }}
          className="fade-in"
        >
          {/* Декоративный градиент сверху */}
          <Box
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 4,
              background: 'linear-gradient(90deg, #ff6b6b, #ffa726, #42a5f5, #ab47bc)'
            }}
          />

          {/* Иконка ошибки */}
          <Box
            sx={{
              width: 120,
              height: 120,
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ffa726 100%)',
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              margin: '0 auto 30px',
              animation: 'float 3s ease-in-out infinite',
              position: 'relative'
            }}
          >
            <LockIcon sx={{ fontSize: 60, color: 'white' }} />
            <Box
              sx={{
                position: 'absolute',
                top: -5,
                right: -5,
                width: 40,
                height: 40,
                background: '#ff4757',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <WarningIcon sx={{ fontSize: 24, color: 'white' }} />
            </Box>
          </Box>

          {/* Заголовок */}
          <Typography 
            variant="h3" 
            gutterBottom
            sx={{
              background: 'linear-gradient(135deg, #ff6b6b 0%, #ffa726 100%)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              fontWeight: 'bold',
              marginBottom: 2,
              fontSize: { xs: '2rem', sm: '3rem' }
            }}
          >
            403
          </Typography>

          <Typography 
            variant="h5" 
            gutterBottom
            sx={{
              color: '#2c3e50',
              fontWeight: 'bold',
              marginBottom: 2
            }}
          >
            Доступ запрещён
          </Typography>

          <Typography 
            variant="body1" 
            color="text.secondary"
            sx={{ 
              fontSize: '1.2rem', 
              marginBottom: 4,
              lineHeight: 1.6
            }}
          >
            У вас нет разрешения для доступа к этой странице.<br />
            Пожалуйста, войдите в систему или обратитесь к администратору.
          </Typography>

          {/* Кнопки действий */}
          <Box 
            sx={{ 
              display: 'flex', 
              gap: 2, 
              justifyContent: 'center',
              flexWrap: 'wrap'
            }}
          >
            <Button
              variant="contained"
              startIcon={<LoginIcon />}
              onClick={() => navigate('/login')}
              sx={{
                background: 'linear-gradient(135deg, #0878ff 0%, #244a77 100%)',
                color: 'white',
                fontWeight: 'bold',
                fontSize: '1rem',
                padding: '12px 24px',
                borderRadius: 3,
                textTransform: 'none',
                boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(135deg, #5a6fd8 0%, #6a4190 100%)',
                  boxShadow: '0 12px 35px rgba(102, 126, 234, 0.4)',
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              Войти в систему
            </Button>

            <Button
              variant="outlined"
              startIcon={<HomeIcon />}
              onClick={() => navigate('/')}
              sx={{
                borderColor: '#0878ff',
                color: '#0878ff',
                fontWeight: 'bold',
                fontSize: '1rem',
                padding: '12px 24px',
                borderRadius: 3,
                textTransform: 'none',
                borderWidth: 2,
                '&:hover': {
                  borderColor: '#5a6fd8',
                  backgroundColor: 'rgba(102, 126, 234, 0.1)',
                  borderWidth: 2,
                  transform: 'translateY(-2px)'
                },
                transition: 'all 0.3s ease'
              }}
            >
              На главную
            </Button>
          </Box>

          {/* Дополнительная информация */}
          <Box
            sx={{
              marginTop: 4,
              padding: 3,
              backgroundColor: 'rgba(102, 126, 234, 0.1)',
              borderRadius: 2,
              borderLeft: '4px solid #0878ff'
            }}
          >
            <Typography 
              variant="body2" 
              color="text.secondary"
              sx={{ fontStyle: 'italic' }}
            >
              <strong>Подсказка:</strong> Если вы считаете, что получили эту ошибку по ошибке, 
              обратитесь к администратору системы или попробуйте войти заново.
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}

export default UnauthorizedPage;
